import React from 'react';

export default function GoogleLinkedText() {
  return (
    <>
      <p>
        <b>Google</b>
        {' '}
        account is linked.
      </p>
      <p>Disconnect your account by clicking the Google Account button.</p>
    </>
  );
}
